import { useState } from 'react';
import SelectElement from '../../../../../components/forms/SelectElement';
import Modal from '../../../../../components/modals/Modal';
import EditCard from '../EditCard';
import type {
	Category,
	Question as IQuestion
} from '../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../data/interface-question-bank';
import type { OptionObjMustHaves } from '../../../../../data/interface-utils';

interface QuestionProps {
	categories: Category[];
	question: IQuestion;
	questionBankID: QuestionBankID;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}

const ViewEditCategory = ({
	categories,
	question,
	questionBankID,
	onUpdate
}: QuestionProps) => {
	const [edit, setEdit] = useState(false);
	const [categoryID, setCategoryID] = useState<string>(question.categoryID);

	const handleUpdate = () => {
		onUpdate(question.id, 'categoryID', categoryID)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	const getCategoryName = () => {
		const cat = categories.find((c) => c.id === categoryID);
		return cat !== undefined ? cat.name : 'Categoría no encontrada';
	};

	const loadCategories = (): OptionObjMustHaves[] => {
		const cats: OptionObjMustHaves[] = [];
		categories
			?.filter((c) => c.questionBank === questionBankID)
			.map((cat) => {
				return cats.push({ id: cat.id, value: cat.name });
			});
		return cats;
	};

	return (
		<>
			<EditCard label='Categoría' onEdit={setEdit}>
				<p>{getCategoryName()}</p>
			</EditCard>

			<Modal
				actionBtnText='Actualizar'
				handleAction={handleUpdate}
				headline='Actualiza la Categoría'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				<SelectElement
					defaultOption='Elige una categoría'
					id='categoryID'
					icon='ballot'
					iconFam='material-icons'
					label='Elige una categoría'
					options={loadCategories()}
					value={categoryID}
					handleChange={(v) => {
						setCategoryID(v);
					}}
				/>
			</Modal>
		</>
	);
};
export default ViewEditCategory;
